module.exports = __webpack_public_path__ + "img/flipper_front@2x.62d0389f.png";